<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="320">
      <v-card>
        <v-card-title class="text-h5">
          Solicitar ajuda
        </v-card-title>
        <v-card-text>
          <v-form novalidate ref="form" v-model="valid" lazy-validation>
            <v-text-field
              v-model="subject"
              :rules="subjectRule"
              label="Assunto"
              required
              filled
              placeholder=""
              ref="cellphone"
            ></v-text-field>
            <v-textarea
              v-model="message"
              :rules="messageRule"
              label="Mensagem"
              required
              filled
              value="Minha Mensagem..."
            ></v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-grey darken-1" text @click="dialogClose">
            Fechar
          </v-btn>
          <v-btn class="mr-4" color="green darken-1" text @click="sendMessage">
            Submeter
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import eventBus from "../../../../main";
export default {
  name: "MessageSuportClient",
  data: () => ({
    valid: false,
    dialog: false,
    message: "",
    subject: "",
    subjectRule: [
      v => !!v || "Assunto é obrigatório",
      v => (v && v.length >= 10) || "Deve ter no mínimo 10 caracter"
    ],
    messageRule: [
      v => !!v || "Mensagem é obrigatória",
      v => (v && v.length >= 30) || "Deve ter no mínimo 30 caracter"
    ]
  }),
  methods: {
    sendMessage() {
      if (this.$refs.form.validate()) {
        let payload = {
          name: this.$store.getters.getFullName,
          phone: this.$store.getters.getCellphone,
          subject: this.subject,
          message: this.message,
          email: this.$store.getters.getEmail
        };
        this.$store.dispatch("sendMessageToOpenTicket", payload);
      }
      return false;
    },
    dialogClose() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
      this.dialog = false;
    }
  },
  created() {
    const self = this;
    eventBus.$on("openMessageToSendEmail", function(payload) {
      self.dialog = payload;
    });
  }
};
</script>

<style scoped></style>
